import axios from 'axios';
import store from '../store/store';

// Global request tracking for the top progress bar.
// Every in-flight axios request increments a counter; the bar is shown while
// the counter is > 0 and hidden when it returns to 0. The counter is always
// decremented — on success AND on error — so a failed request can't leave the
// bar stuck.

axios.interceptors.request.use(
    config => {
        store.dispatch({type: 'requestStart'});
        return config;
    },
    error => {
        store.dispatch({type: 'requestEnd'});
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        store.dispatch({type: 'requestEnd'});
        return response;
    },
    error => {
        store.dispatch({type: 'requestEnd'});
        return Promise.reject(error);
    }
);
